<div class="flex flex-row flex-nowrap relative items-center">
  <button class="flex flex-col items-center justify-center bg-e-dark-green size-8 md:size-10 rounded-full absolute left-0" (click)="swipeLeft()">
    <img src="/assets/images/icons/arrow_light.svg"/>
  </button>
  <div class="bg-e-light-green flex flex-row rounded-md pt-3 px-5 md:px-[35px] mx-4 overflow-hidden">
    <div #lifestylelist class="grid grid-flow-col grid-cols-auto flex-nowrap overflow-x-scroll scrollbar-hide">
      @for (style of lifestyles; track style; let i = $index) {
        <div class="lifestyle flex flex-col px-3 cursor-pointer" id="lifestyleselection-{{i}}" (click)="changeLifestyle(style.id)">
          <img class="h-[31px] mx-auto" alt="logo {{style.name}}" src="./assets/images/icons/lifestyle/icon_leefstijl_{{style.id}}.svg" />
          <span class="text-sm mx-auto text-nowrap capitalize" [ngClass]="{'font-bold': lifestyleid === style.id}">{{style.name}}</span>
          <div class=" rounded-full w-full h-1 mt-2" [ngClass]="{'bg-e-orange': lifestyleid === style.id, 'bg-transparant': lifestyleid !== style.id}"></div>
        </div>
      }
    </div>
  </div>
  <button class="flex flex-col items-center justify-center bg-e-dark-green size-8 md:size-10 rounded-full absolute right-0" (click)="swipeRight()">
    <img src="/assets/images/icons/arrow_light.svg" class="rotate-180"/>
  </button>
</div>
